import React, { useState } from "react";
import { Col, Row, UiButton, UiCenter, UiDivider, UiTabPanel, UiText, useBreakpointValue } from "~/components/elements";
import { AvailableStyles } from "~/pages/result-detail/AvailableStyles";
import UpgradePlanModal from "~/components/modals/UpgradePlanModal";
import { useAppSelector } from "~/hooks";
import { ArrowRightIcon } from "~/components/icons/SvgIcons";
import { PAGES } from "~/constants";
import { useHistory } from "react-router-dom";
import { appConfig } from "~/config";
import { createPaymentSession } from "~/redux/dashboards/thunk";
import { requestOK } from "redux-thunk-kit";
import { unwrapResult } from "@reduxjs/toolkit";
import { AppError } from "ry-error-wrapper";
import { AppDispatch } from "~/redux/root-store";
import { useDispatch } from "react-redux";

export const CreateMoreHeadshotsTabPanel: React.FC<{ jobId: string }> = ({ jobId }) => {
  const history = useHistory();
  const dispatch: AppDispatch = useDispatch();
  const jobItemData = useAppSelector(state => state.dashboard.jobItemData);
  const [showUpgradePlanModal, setShowUpgradePlanModal] = useState(false);
  const [upsellQuantity, setQuantity] = useState(0);
  const vrTitle = useBreakpointValue<any>({ base: "headline4", sm: "headline2" });
  const vrBody1 = useBreakpointValue<any>({ base: "body2", sm: "body1" });
  const vrBody2 = useBreakpointValue<any>({ base: "body3", sm: "body2" });
  const vrDollar = useBreakpointValue<any>({ base: "title2", sm: "title1" });
  const vrNo = useBreakpointValue<any>({ base: "title1", sm: "headline4" });

  // TMP Copied from the Upgrade Plan Modal since we are not disable the All Access Plan
  const goToPayment = async (type: "upsell" | "all_access", quantity: number) => {
    const packageKey = "upsell";
    setQuantity(quantity);

    const postData = {
      cancel_url: `${appConfig.url}${PAGES.PAYMENT_CANCELLED}?session_id={CHECKOUT_SESSION_ID}&package=${packageKey}&job_id=${jobId}&quantity=${quantity}&billing_type=${type}`,
      success_url: `${appConfig.url}${PAGES.PAYMENT_SUCCESSFUL}?session_id={CHECKOUT_SESSION_ID}&package=${packageKey}&job_id=${jobId}&quantity=${quantity}&billing_type=${type}`,
      package_key: packageKey,
      job_id: type === "upsell" ? jobId : undefined,
      quantity: type === "upsell" ? quantity : undefined,
      type,
    };

    const resAction = await dispatch(createPaymentSession({ data: postData }));

    if (requestOK(resAction, createPaymentSession)) {
      const results = unwrapResult(resAction);
      if (results.checkout_url) {
        window.open(results.checkout_url, "_self");
      } else {
        throw new AppError("No checkout URL");
      }
    }
  };

  return (
    <UiTabPanel>
      <UpgradePlanModal
        upgradeType="upsell"
        visible={showUpgradePlanModal}
        onClose={() => setShowUpgradePlanModal(false)}
        data={{ jobId, quantity: upsellQuantity }}
      />
      <Col mt={1}>
        <Col align="center">
          <UiText textAlign="center" vr={vrTitle}>
            Get more styles, for way less
          </UiText>
          {jobItemData?.type !== "two_person" && (
            <UiText textAlign="center" vr={vrBody1} mt={3}>
              Each style (outfit & background) combination is only{" "}
              <UiText as="span" vr={vrDollar} color="blue">
                $3.
              </UiText>
            </UiText>
          )}

          <Col mt={5}>
            {jobItemData?.has_upsell_pending ? (
              <UiButton
                size="sm"
                variant="outline"
                borderColor="navy"
                bg="#353FB5"
                color="navy"
                _hover={{ bg: "navy", color: "navy" }}
                onClick={() => {
                  history.push(`${PAGES.SELECT_STYLES}?job_id=${jobId}&type=upsell`);
                }}
              >
                <Row align="center" mx={3}>
                  <UiText vr="title1" color="white">
                    {jobItemData?.upsells
                      ?.filter(upsell => upsell.status === "pending")
                      .reduce((total, upsell) => total + upsell.max_outfit, 0)}{" "}
                    more styles available. Add now
                  </UiText>
                  <ArrowRightIcon boxSize={5} dColor="white" />
                </Row>
              </UiButton>
            ) : (
              <>
                <UiText textAlign="center" vr={vrBody2}>
                  Select number of new styles:
                </UiText>
                <Row mt={5} gap={4}>
                  {[2, 3, 4].map(no => (
                    <UiCenter
                      rounded="xl"
                      bg="white"
                      key={no}
                      w={{ base: "2.875rem", sm: "4.375rem" }}
                      h={{ base: "2.875rem", sm: "4.375rem" }}
                      _hover={{ cursor: "pointer" }}
                      onClick={() => {
                        goToPayment("upsell", no);
                        // setShowUpgradePlanModal(true);
                      }}
                    >
                      <UiText vr={vrNo}>{no}</UiText>
                    </UiCenter>
                  ))}
                </Row>
              </>
            )}
          </Col>
        </Col>
        <UiDivider text="Popular styles" containerProps={{ my: 5, w: "full" }} />
        <AvailableStyles type="upsell" photoshootType={jobItemData?.type || "one_person"} />
      </Col>
    </UiTabPanel>
  );
};
